<template>
  <v-row no-gutters style="height: 100%" @click="timer > 0 ? timer = timerDefault : ''">
    <v-col cols="12" md="6" offset-md="3">
      <v-card height="100%">
        <v-container fluid>
          <p class="caption text-right" v-if="timer > 0">Auto signout in {{logoutCountdown}}</p>
          <p class="headline text-center">Welcome {{fullname}}</p>
          <div class="text-center" v-if="loading">
            <v-progress-circular
              indeterminate
              color="primary"
              :size="100"
            ></v-progress-circular>
            <br>
           Loading...
          </div>
          <template v-else>
          <v-card class="card--flex-toolbar mb-2 rounded-xl" v-if="unacknowledgedFiles.length > 0">
          <v-app-bar flat dense dark color="red darken-1">
            <v-toolbar-title class="body-2">Incomplete Items</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-chip dark color="white" small outlined>{{unacknowledgedFiles.length}}</v-chip>
          </v-app-bar>

          <v-divider></v-divider>
          <v-row no-gutters class="text-center pa-2">
            <template v-if="!activeUnacknowledgedFolder">
              <v-col cols="4" v-for="(folder, i) in unacknowledgedFolders" :key="i">
                <v-card flat class="mt-2">
                  <v-btn color="primary" @click="activeUnacknowledgedFolder = folder.folderName" target="_blank" large icon>
                    <v-badge
                      color="red"
                      overlap
                    >
                      <template v-slot:badge>
                        <span>{{folder.count}}</span>
                      </template>
                      <v-icon x-large>folder</v-icon>
                    </v-badge>
                  </v-btn>
                  <p class="text-center caption mb-0">{{folder.folderName}}</p>
                </v-card>
              </v-col>
            </template>
            <v-col cols="4" v-else-if="unacknowledgedFolders.length > 1">
              <v-card flat class="mt-3">
                <v-btn color="primary" @click="activeUnacknowledgedFolder = null" large icon>
                    <v-icon x-large>keyboard_backspace</v-icon>
                  </v-btn>
                  <p class="text-center caption mb-0">back</p>
              </v-card>
            </v-col>
            <v-col cols="4" v-for="(file, i) in filteredUnacknowledgedFiles" :key="i">
              <v-card flat>
                <v-btn color="primary" @click="setActiveFile(file, 'unacknowledged')" target="_blank" large icon>
                  <v-icon x-large v-if="!file.interactive">insert_drive_file</v-icon>
                  <v-icon x-large v-else>mdi-file-sign</v-icon>
                </v-btn>
                <p class="text-center caption mb-0">{{file.item_name}}</p>
                <p class="text-center body-1">{{file.filename}}.{{file.extension}}</p>
              </v-card>
            </v-col>
          </v-row>
        </v-card>


        <v-card class="card--flex-toolbar rounded-xl mt-2" v-if="acknowledgedFiles.length > 0">
        <v-app-bar flat dense dark color="green lighten-1">
          <v-toolbar-title class="body-2">Completed Items</v-toolbar-title>
          <v-spacer></v-spacer>
            <v-chip color="white" small outlined>{{acknowledgedFiles.length}}</v-chip>
        </v-app-bar>

        <v-divider></v-divider>
        <v-row no-gutters class="text-center pa-2">
          <template v-if="!activeAcknowledgedFolder">
            <v-col cols="4" v-for="(folder, j) in acknowledgedFolders" :key="j">
              <v-card flat class="mt-2">
                <v-btn color="primary" @click="activeAcknowledgedFolder = folder.folderName" target="_blank" large icon>
                  <v-badge
                    color="green"
                    overlap
                  >
                    <template v-slot:badge>
                      <span>{{folder.count}}</span>
                    </template>
                    <v-icon x-large>folder</v-icon>
                  </v-badge>
                </v-btn>
                <p class="text-center caption mb-0">{{folder.folderName}}</p>
              </v-card>
            </v-col>
          </template>
          <v-col cols="4" v-else-if="acknowledgedFolders.length > 1">
            <v-card flat class="mt-3">
              <v-btn color="primary" @click="activeAcknowledgedFolder = null" large icon>
                  <v-icon x-large>keyboard_backspace</v-icon>
                </v-btn>
                <p class="text-center caption mb-0">back</p>
            </v-card>
          </v-col>
          <v-col cols="4" v-for="(file, j) in filteredAcknowledgedFiles" :key="j">
            <v-card flat>
              <v-btn color="primary" @click="setActiveFile(file, 'acknowledged')" target="_blank" large icon>
                  <v-icon x-large>insert_drive_file</v-icon>
                </v-btn>
                <p class="text-center caption mb-0">{{file.item_name}}</p>
                <div v-if="file.extension === ''">
                  <p class="text-center body-1" style="margin-bottom:0px">{{file.filename}}.{{file.extension}}</p>
                  <div style="display:flex; justify-content:center; align-items:center">
                    <p class="text-center caption mb-0">Score:</p>
                    <div>
                      <p class="text-center caption mb-0" v-if="file.PassFail == 'Pass'" style="color:darkgreen">{{file.percentage | formatPercentage}}%</p>
                      <p class="text-center caption mb-0" v-if="file.PassFail == 'Fail'" style="color:darkred">{{file.percentage | formatPercentage}}%</p>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <p class="text-center body-1">{{file.filename}}.{{file.extension}}</p>
                </div>
            </v-card>
          </v-col>
        </v-row>
      </v-card>
          </template>
        </v-container>
      </v-card>
    </v-col>
    <v-snackbar
      v-model="snackbar"
      :timeout="snackbarTimeout"
    >
      {{snackbarText}}
      <v-btn dark text @click.native="snackbar = false">Close</v-btn>
    </v-snackbar>
    <template>
        <v-dialog v-model="dialog" persistent max-width="700px">
          <v-card rounded>
            <v-card-title>
              <span class="headline">Acknowledge Document</span>
            </v-card-title>
            <v-card-text v-if="activeFile !== null">
              By Submitting this form you are confirming you have {{['mp4', 'png', 'jpg', 'jpeg'].indexOf(activeFile.extension) !== -1 ? 'viewed' : 'read'}} and understood the file {{activeFile.filename}}.{{activeFile.extension}}
              <v-checkbox :label="'I confirm that I have ' + (['mp4', 'png', 'jpg', 'jpeg'].indexOf(activeFile.extension) !== -1 ? 'viewed' : 'read') + ', understood and acknowledged this ' + (activeFile.extension === 'mp4' ? 'video' : (['png', 'jpg', 'jpeg'].includes(activeFile.extension) ? 'image' : 'document')) + '.'" v-model="confirmCheckbox"></v-checkbox> 
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click.native="dialog = false">Cancel</v-btn>
              <v-btn color="blue darken-1" text @click.native="acknowledgeFile" :disabled="confirmCheckbox === false">Submit</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
    </template>
    <template>
        <v-dialog v-model="dialogQuiz" persistent max-width="700px">
          <v-card rounded>
            <v-card-title>
              <span class="headline">Connected Quiz</span>
            </v-card-title>
            <v-card-text v-if="activeFile !== null">
                              There is a quiz that has been attached to this document,
                              <br>
                              Quiz Name: <strong>{{ activeFile.quiz_name }}</strong>
                              </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click.native="dialogQuiz = false">Take Quiz Later</v-btn>
              <v-btn color="blue darken-1" text @click.native="takeQuizNow">Take Quiz Now</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
    </template>
    <template>
      <v-dialog v-model="alertDialog" persistent max-width="500px">
        <v-card rounded>
          <v-card-text style="white-space: pre-wrap">{{ alertMessage }}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click.native="confirmAlert">OK</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
    <template>
      <v-dialog v-model="viewFileDialog" persistent fullscreen>
          <v-card rounded color="#1e2d4f">
            <v-card-title>
              <span class="headline" style="color: #fff">View {{ activeFile && activeFile.extension === 'mp4' ? 'Video' : 'Document' }}</span>
              <v-spacer></v-spacer>
              <v-btn color="#fff" text @click.native="closeViewFileDialog">Close</v-btn>
            </v-card-title>
            <v-card-text v-if="activeFile !== null" style="padding-left: 0px; padding-right: 0px;">
              <img v-if="activeFile.extension === 'jpg' && viewFileDialog === true" :src="activeFile.fileref" allowfullscreen style="width: 100%; height: auto"></img>
              <img v-if="activeFile.extension === 'jpeg' && viewFileDialog === true" :src="activeFile.fileref" allowfullscreen style="width: 100%; height: auto"></img>
              <img v-if="activeFile.extension === 'png' && viewFileDialog === true" :src="activeFile.fileref" allowfullscreen style="width: 100%; height: auto"></img>
              <video v-if="activeFile.extension === 'mp4' && viewFileDialog === true" controls style="width: 100%; height: auto">
                <source :src="activeFile.fileref" type="video/mp4">
              </video>
                <!-- <iframe id="fileIframe" v-if="activeFile.extension === 'mp4' && viewFileDialog === true" :src="activeFile.fileref" allowfullscreen style="width: calc(calvw - 50px)(100vw - 50px); height: calc(100vh - 120px);"></iframe> -->
              <iframe id="fileIframe" v-if="activeFile.extension === 'pdf'" :src="`/pdfjs-4.0.379-dist/web/viewer.html?file=${encodeURIComponent(activeFile.fileref)}#toolbar=0&pagemode=none`" style="width: 100vw; height: calc(100vh - 120px); border-color: #1e2d4f;"></iframe>
              <p class="text-center" style="color: #fff" v-if="activeFile.extension === 'pdf'">If you are having trouble viewing this file <a style="color: #fff" :href="activeFile.fileref" target="_blank">click here</a> to open it in a new tab.</p>
            </v-card-text>
          </v-card>
        </v-dialog>
    </template>

  </v-row>
</template>

<script>

import moment from 'moment'
import axios from 'axios'

export default {
  data () {
    return {
      snackbar: false,
      snackbarText: '',
      currentJob: false,
      snackbarTimeout: 1000,
      company: this.$store.getters.company,
      timer: this.$store.getters.signoutInterval * 60,
      timerDefault: this.$store.getters.signoutInterval * 60,
      acknowledgedFiles: [],
      unacknowledgedFiles: [],
      dialog: false,
      activeType: null,
      confirmCheckbox: false,
      activeFile: null,
      activeTime: null,
      viewingTime: null,
      emp_id: this.$store.getters.user.empID,
      activeAcknowledgedFolder: null,
      activeUnacknowledgedFolder: null,
      loading: false,
      viewFileDialog: false,
      pdfLoaded: false,
      totalPages: 0,
      quizList: [],
      dialogQuiz: false,
      alertDialog: false,
      alertMessage: '',
      alertResolve: null
    }
  },
  created () {
    this.getFiles()
    this.getQuizList()
  },
  mounted () {
    window.addEventListener('focus', () => {
      this.getFiles()
    })
    this.$store.dispatch('checkLoginTime')
    if (this.timer > 0) {
      let interval = setInterval(() => {
        this.timer--
        if (this.timer === 0) {
          this.$store.dispatch('logout')
          clearInterval(interval)
        }
      }, 1000)
    }
  },
  methods: {
    getQuizList () {
      axios.post(this.url + `/dms-service/get-quizzes.ajax.php`, {
        company: this.company
      })
        .then(res => {
          if (res.data.status) {
            this.quizList = res.data.quizzes
          }
        })
    },
    getQuiz (file) {
      return this.quizList.find(q => q.quiz_id === file.quiz_id)
    },
    zeroFill (number, width) {
      width -= number.toString().length
      if (width > 0) {
        return new Array(width + (/\./.test(number) ? 2 : 1)).join('0') + number
      }
      return number
    },
    closeViewFileDialog () {
      console.log(this.activeFile)
      this.viewFileDialog = false
      if (this.activeType === 'unacknowledged') {
        this.dialog = true
      }
    },
    // This currently always is sent from file as this was made from documents, but when quizzes are able to be applied directly to an employee,
    // send to this function as false to avoid the other end trying to unacknowledge a file that doesnt exist.
    setActiveFile (file, type, sentFromFile = true) {
      console.log('FILE CLICKED:', file)
      this.activeFile = file
      this.activeType = type
      if (file.item_name === 'Quizzes') {
        const quiz = this.getQuiz(file)
        if (sentFromFile === true) {
          if (quiz) {
            console.log(quiz)
            window.open(file.fileref + '&v=' + file.quiz_version_id + '&fromFileAcknowledgement=true', '_blank')
            return
          } else {
            this.snackbarText = 'Quiz not found'
            this.snackbar = true
            return
          }
        } else {
          if (quiz) {
            console.log(quiz)
            window.open(file.fileref + '&v=' + file.quiz_version_id, '_blank')
            return
          } else {
            this.snackbarText = 'Quiz not found'
            this.snackbar = true
            return
          }
        }
      }
      const proceed = () => {
        if (type === 'unacknowledged') {
          this.activeTime = moment()
          this.confirmCheckbox = false
        }
        if (file.interactive) {
          window.open(file.fileref)
          return
        }
        this.viewFileDialog = true
      }
      if (type === 'unacknowledged' && file.intro_message) {
        this.showAlert(file.intro_message).then(proceed)
      } else {
        proceed()
      }
    },
    showAlert (message) {
      this.alertMessage = message
      this.alertDialog = true
      return new Promise(resolve => {
        this.alertResolve = resolve
      })
    },
    confirmAlert () {
      this.alertDialog = false
      const resolve = this.alertResolve
      this.alertResolve = null
      if (resolve) resolve()
    },
    getFiles () {
      this.loading = true
      return axios.post(this.url + `/dms-service/get-files-by-emp.ajax.php`, {
        company: this.company,
        emp_id: this.emp_id
      })
        .then(response => {
          this.acknowledgedFiles = response.data.acknowledged
          this.unacknowledgedFiles = response.data.unacknowledged

          return new Promise(resolve => {
            setTimeout(() => {
              this.loading = false
              if (this.unacknowledgedFolders.findIndex(f => f.folderName === this.activeUnacknowledgedFolder) === -1) {
                this.activeUnacknowledgedFolder = null
              }
              resolve()
            }, 200)
          })
        })
    },
    acknowledgeFile () {
      this.viewingTime = this.activeTime ? moment().diff(this.activeTime, 's') : null
      let file = this.activeFile
      file.viewingTime = this.viewingTime
      file.emp_id = this.emp_id
      file.company = this.company
      axios.post(this.url + `/dms-service/acknowledge-file.ajax.php`, file)
        .then(response => {
          this.activeTime = null
          this.dialog = false
          return this.getFiles()
        })
        .then(() => {
          this.completeQuizPrompt()
        })
    },
    completeQuizPrompt () {
      if (this.activeFile && this.activeFile.quiz_id) {
        this.dialogQuiz = true
      }
    },
    takeQuizNow () {
      this.dialogQuiz = false
      let quizFile = this.unacknowledgedFiles.find(f =>
        f.type === 'quiz' &&
      f.quiz_id === this.activeFile.quiz_id
      )
      this.setActiveFile(quizFile, 'unacknowledged', true)
    }
  },
  computed: {
    fullname () {
      return this.$store.getters.user ? this.$store.getters.user.fname + ' ' + this.$store.getters.user.sname : ''
    },
    url () {
      return this.$store.getters.url
    },
    acknowledgedFolders () {
      let folderArray = []
      for (let file of this.acknowledgedFiles) {
        let index = folderArray.findIndex(f => f.folderName === file.item_name)
        if (index === -1) {
          folderArray.push({folderName: file.item_name, count: 1, item_id: file.item_id})
        } else {
          folderArray[index].count++
        }
      }
      if (folderArray.length === 1) {
        this.activeAcknowledgedFolder = folderArray[0].folderName
      }
      return folderArray
    },
    filteredAcknowledgedFiles () {
      let acknowledgedFiles = [...this.acknowledgedFiles]
      return acknowledgedFiles.filter(f => f.item_name === this.activeAcknowledgedFolder)
    },
    unacknowledgedFolders () {
      let folderArray = []
      for (let file of this.unacknowledgedFiles) {
        let index = folderArray.findIndex(f => f.folderName === file.item_name)
        if (index === -1) {
          folderArray.push({folderName: file.item_name, count: 1, item_id: file.item_id})
        } else {
          folderArray[index].count++
        }
      }
      if (folderArray.length === 1) {
        this.activeUnacknowledgedFolder = folderArray[0].folderName
      }
      return folderArray
    },
    filteredUnacknowledgedFiles () {
      let unacknowledgedFiles = [...this.unacknowledgedFiles]
      return unacknowledgedFiles.filter(f => f.item_name === this.activeUnacknowledgedFolder)
    },
    logoutCountdown () {
      let d = this.timer
      d = Number(d)
      var h = this.zeroFill(Math.floor(d / 3600), 2)
      var m = this.zeroFill(Math.floor(d % 3600 / 60), 2)
      var s = this.zeroFill(Math.floor(d % 3600 % 60), 2)

      return h + ':' + m + ':' + s
    }
  },
  filters: {
    formatDate (val) {
      return val !== undefined ? moment(val).format('DD/MM/YYYY HH:mm') : '--'
    },
    formatPercentage (val) {
      if (val === undefined) return '--'
      const num = Number(val)
      if (isNaN(num)) return val
      if (Number.isInteger(num) || num % 1 === 0) return num.toString()
      if (num.toFixed(2).endsWith('.00')) return Math.round(num).toString()
      return num.toFixed(2)
    }
  }
}
</script>

<style>
  .input-group.checkbox label{
    height: auto;
    position: absolute;
    white-space: normal;
    max-width: 90%!important;
  }
</style>


// WEBPACK FOOTER //
// src/components/Hello.vue